import { isBreakpointMobileSync, cdnService, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate } from 'tslib';
import { Component, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';

var RelevantInformation = /** @class */ (function (_super) {
    __extends(RelevantInformation, _super);
    function RelevantInformation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.title = '';
        _this.description = '';
        _this.loading = true;
        _this.pageImage = '';
        _this.pageBackground = '';
        return _this;
    }
    RelevantInformation.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRegulatoryInformationPage()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RelevantInformation.prototype.getRegulatoryInformationPage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var page, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        return [4 /*yield*/, magic.methods.pages.get({
                                slug: 'customersupport_pagcor_regulatory_info',
                                lang: this.magicConfig.language,
                            })];
                    case 1:
                        page = (_a.sent());
                        this.title = page.title || '';
                        this.description = page.description || '';
                        this.pageImage = page.image || '';
                        this.pageBackground = page.background || '';
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Failed to fetch title from CMS:', error_1);
                        return [3 /*break*/, 4];
                    case 3:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(RelevantInformation.prototype, "topImage", {
        get: function () {
            if (isBreakpointMobileSync() && this.pageImage) {
                return cdnService.getPageImageUrl(this.pageImage);
            }
            else if (this.pageBackground) {
                return cdnService.getPageBackgroundUrl(this.pageBackground);
            }
            else if (this.pageImage) {
                return cdnService.getPageImageUrl(this.pageImage);
            }
            return '';
        },
        enumerable: false,
        configurable: true
    });
    RelevantInformation.prototype.closeModal = function () {
        this.$emit('close');
    };
    RelevantInformation.prototype.closeTab = function () {
        window.close();
        setTimeout(function () {
            if (!window.closed) {
                history.back();
            }
        }, 100);
    };
    RelevantInformation = __decorate([
        Component({
            name: 'pagcor-relevant-information-modal',
        })
    ], RelevantInformation);
    return RelevantInformation;
}(Mixins(MagicConfigMixin)));

export default RelevantInformation;
